var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// tslint:disable:no-console
import { Client } from "sb-jackpot-client";
const userLoginTopic = "sb_UserInfo.login";
const userLogoutTopic = "sb_UserInfo.logout";
const ResetWinAnimationJackpotTopic = "sb_jackpot_reset_win_animations";
const WinningAnimationShownTopicName = "sb_jackpot_won_shown";
export class JackpotDataProvider {
    constructor() {
        this.jackpotsList = [];
        this.isConnected = false;
        /* istanbul ignore next */
        this.logTraceMsg = (message, ...optionalParams) => console.log(`[JackpotDataProvider] ${message}`, ...optionalParams);
        /* istanbul ignore next */
        this.checkInit = () => __awaiter(this, void 0, void 0, function* () {
            /* istanbul ignore next */
            if (!this.wasInit) {
                throw "Not Configured!";
            }
            /* istanbul ignore next */
            yield this.wasInit.catch((e) => {
                /* istanbul ignore next */
                console.log(e);
            });
            /* istanbul ignore next */
        });
        this.getJackpotData = (jackpotIds) => {
            return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
                if (jackpotIds && jackpotIds.length > 0) {
                    try {
                        yield this.checkInit();
                        const jackpotData = this.client.jackpotsList(jackpotIds);
                        resolve(jackpotData);
                    }
                    catch (e) {
                        /* istanbul ignore next */
                        console.log(e);
                        /* istanbul ignore next */
                        reject(e);
                    }
                }
                resolve(undefined);
            }));
        };
        this.subscribeToUserLoginLogout = () => {
            this.bus.subscribe(userLoginTopic, this.onUserLogin);
            this.bus.subscribe(userLogoutTopic, this.onUserLogout);
            this.bus.subscribe(WinningAnimationShownTopicName, this.onWinningAnimationShown);
        };
        this.connectMessageBus = (msgBus) => {
            this.bus = msgBus;
            this.subscribeToUserLoginLogout();
        };
        this.reconfigureWithToken = (token, isLoggedInUser = false, isFirstSuccesfullLogin) => __awaiter(this, void 0, void 0, function* () {
            /* istanbul ignore next */
            this.logTraceMsg("On configure with new token:", token);
            if (!this.config) {
                return Promise.reject("Cant find config. Call 'setConfig' first");
            }
            let config = Object.assign(Object.assign({}, this.config), { token });
            let fullConfigPromise = this.configure(config);
            if (isLoggedInUser) {
                fullConfigPromise = fullConfigPromise
                    .then(this.subscribeForJackpotWin);
            }
            if (isFirstSuccesfullLogin) {
                fullConfigPromise = fullConfigPromise
                    .then(() => this.getWon());
            }
            return fullConfigPromise;
        });
        /* istanbul ignore next */
        this.createApiClient = (config) => {
            this.client = new Client(config);
        };
        this.disconnectApiClient = () => {
            if (this.subscribtionAllWon) {
                this.subscribtionAllWon.unsubscribe();
                this.subscribtionAllWon = undefined;
            }
            if (this.client) {
                this.client.disconnect().catch((e) => Promise.reject(e));
            }
        };
        this.configure = (config) => __awaiter(this, void 0, void 0, function* () {
            /* istanbul ignore next */
            this.logTraceMsg("On configure with next config", config);
            if (this.isConnected && this.config && this.config.token === config.token) {
                /* istanbul ignore next */
                this.logTraceMsg("same token, no need to reconnect");
                return Promise.resolve();
            }
            !this.firstUsedToken && (this.firstUsedToken = config.token);
            this.config = config;
            this.disconnectApiClient();
            this.createApiClient(this.config);
            this.wasInit = this.initClient().then(() => {
                this.waitInitResolver();
            });
            yield this.wasInit;
        });
        /* istanbul ignore next */
        this.getWon = () => __awaiter(this, void 0, void 0, function* () {
            if (this.wasInit) {
                yield this.wasInit
                    .then(this.getWonJackpotData)
                    .catch((e) => Promise.reject(e));
            }
        });
        this.publishJackpotWon = (jackpot, userId) => {
            const JacpotWonTopic = "sb_jackpot_won";
            const wonByMe = jackpot.userID === userId;
            /* istanbul ignore next */
            this.logTraceMsg("publishJackpotWon ", jackpot, wonByMe);
            this.bus.post({ [JacpotWonTopic]: { jackpot, wonByMe } });
        };
        this.notifyJackpotWon = (wonJackpots) => __awaiter(this, void 0, void 0, function* () {
            if (this.userInfo && wonJackpots.length) {
                this.handleJackpotWonNotifications(wonJackpots);
            }
        });
        /* istanbul ignore next */
        this.handleJackpotWonNotifications = (wonJackpots) => {
            const userID = parseInt(this.userInfo ? this.userInfo.UserId : "0");
            /* istanbul ignore next */
            this.logTraceMsg("Jackpot Won Notification to be send", wonJackpots.length, userID);
            this.getJackpotData(wonJackpots.map(jp => jp.jackpotId)).then(jackpots => {
                if (jackpots) {
                    wonJackpots.forEach((jackpot) => {
                        const jpData = jackpots.find(jp => jp.id === jackpot.jackpotId);
                        if (jpData) {
                            jackpot.externalName = jpData.externalName;
                        }
                    });
                }
                /* istanbul ignore next */
                wonJackpots.forEach((jackpot) => {
                    /* istanbul ignore next */
                    this.publishJackpotWon(jackpot, userID);
                });
            }).catch(e => {
                /* istanbul ignore next */
                console.log(e);
            });
        };
        this.getWonJackpotData = () => __awaiter(this, void 0, void 0, function* () {
            /* istanbul ignore next */
            this.logTraceMsg("Getting Won Jackpots!");
            if (!this.userInfo) {
                /* istanbul ignore next */
                this.logTraceMsg("Getting Won Jackpots! - No User Info");
                return;
            }
            return this.getWonJackpotsData(this.userInfo.UserId)
                .then(this.notifyJackpotWon);
        });
        this.getWonJackpotsData = (userId, lastLogoutUtcDate) => __awaiter(this, void 0, void 0, function* () {
            if (this.wasInit) {
                return this.client.wonJackpots(userId, lastLogoutUtcDate);
            }
            return [];
        });
        this.initClient = () => __awaiter(this, void 0, void 0, function* () {
            /* istanbul ignore next */
            this.logTraceMsg("Initiaziing Jackpot Client!");
            try {
                if (this.userInfo) {
                    const response = yield this.client.connect();
                    this.isConnected = response.success;
                }
            }
            catch (e) {
                /* istanbul ignore next */
                console.log("Connection failed with exception:", e);
            }
            return;
        });
        this.subscribeForJackpotWin = () => __awaiter(this, void 0, void 0, function* () {
            if (this.userInfo) {
                try {
                    /* istanbul ignore next */
                    this.logTraceMsg("Subscribing to winning notifications");
                    if (this.subscribtionAllWon) {
                        /* istanbul ignore next */
                        this.logTraceMsg("already subscribed");
                        return;
                    }
                    this.subscribtionAllWon = yield this.client.subscribeForJackpotUserWin({ userId: this.userInfo.UserId }, this.handleJackpotWonNotifications);
                    /* istanbul ignore next */
                    this.logTraceMsg("Successfull subscription!");
                }
                catch (e) {
                    /* istanbul ignore next */
                    console.log(e);
                }
            }
        });
        this.onUserLogin = (loggedInUserInfo) => {
            this.logTraceMsg("On user Login:", loggedInUserInfo);
            if (!loggedInUserInfo || !loggedInUserInfo.Token) {
                return;
            }
            var isFirstSuccesfullLogin = !this.userInfo && loggedInUserInfo ? true : false;
            this.userInfo = loggedInUserInfo;
            this.reconfigureWithToken(this.userInfo.Token, true, isFirstSuccesfullLogin)
                .catch(e => {
                /* istanbul ignore next */
                console.log(e);
            });
        };
        this.onUserLogout = (info) => {
            this.logTraceMsg("On user Logout", info);
            this.userInfo = undefined;
            let anonymousToken = info && info.token || this.firstUsedToken;
            this.reconfigureWithToken(anonymousToken)
                .catch(e => {
                /* istanbul ignore next */
                console.log(e);
            });
            this.bus.post({ [ResetWinAnimationJackpotTopic]: {} });
        };
        this.onWinningAnimationShown = (message) => __awaiter(this, void 0, void 0, function* () {
            yield this.client.markJackpotsAsSeen(message.userID.toString(), [message.jackpotId]);
        });
        this.waitInit = new Promise((resolve, _) => this.waitInitResolver = resolve);
    }
}
export const jackpotDataProvider = new JackpotDataProvider();
export function getJackpotData(jackpotId) {
    return __awaiter(this, void 0, void 0, function* () {
        return jackpotDataProvider.waitInit.then(() => jackpotDataProvider.getJackpotData(jackpotId));
    });
}
export function configureJackpotProvider(config, msgBus, muteTraceInfoLogs = false) {
    /* istanbul ignore next */
    muteTraceInfoLogs && (jackpotDataProvider.logTraceMsg = () => { });
    jackpotDataProvider.connectMessageBus(msgBus);
    jackpotDataProvider.configure(config).catch((e) => {
        /* istanbul ignore next */
        console.log("configureJackpotProvider error:", e);
    });
}
export function getWonJackpotsData(userId, lastLogoutUtcDate) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield jackpotDataProvider.getWonJackpotsData(userId, lastLogoutUtcDate);
    });
}
window["getJackpotData"] = getJackpotData;
window["configureJackpotProvider"] = configureJackpotProvider;
window["getWonJackpotsData"] = getWonJackpotsData;
//# sourceMappingURL=JackpotDataProvider.js.map